import React from 'react';
import { connect } from 'react-redux';
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import {styles} from "./styles.css";
import { ConnectComponent } from '../../components/connect-component/connect-component';
import { AboutMeComponentV2 } from '../../components-v2/about-me-component/about-me-component'
import { FocusingComponentV2 } from '../../components-v2/focusing-component/focusing-component';
import { ExperienceComponentV2 } from '../../components-v2/experience-component/experience-component';
import { PartnerComponentV2 } from '../../components-v2/partner-component/partner-component';
import { PublicationomponentV2 } from '../../components-v2/publication-component/publication-component';
import { TeachingComponentV2 } from '../../components-v2/teaching-component/teaching-component';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

class Component extends React.Component {
	
	constructor(props){
		super(props);
		this.homeRef = React.createRef();
		this.aboutMeRef = React.createRef();
		this.state = {

		}
	}

	particlesInit = async (main) => {
	
		// you can initialize the tsParticles instance (main) here, adding custom shapes or presets
		// this loads the tsparticles package bundle, it's the easiest method for getting everything ready
		// starting from v2 you can add only the features you need reducing the bundle size
		await loadFull(main);
	  };
	
	particlesLoaded = (container) => {

	};
	
	render() {
		return (
			<React.Fragment>
				<div className="main" ref={this.homeRef}>
					<div className='title'>
						Calvin Ku
					</div>
					<div className='catchPhrase'>
						Highly motivated researcher,<br/>
						Passionate in implementing innovative technology, <br/>
						Loves to play sports
					</div>
					<div className='content'>
						#DeepLearning #ComputerVision #SportsAnalysis #HumanPoseEstimation
					</div>
					<div style={{display: "flex", flexDirection: "column", paddingTop: "30px", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
						<button 
							onClick={()=>{
								window.scrollTo(0, this.aboutMeRef.current.offsetTop) 
							}}
							className='slide'>Learn More</button>
							<div style={{paddingTop: "30px"}}>
								<a>
									<ArrowCircleDownIcon 
										style={{fontSize: "40px", color: "white"}}
										onClick={()=>{
											window.scrollTo(0, this.aboutMeRef.current.offsetTop)
										}}/>
								</a>
							</div>
						{/* <svg style={{fill: "white", marginTop: "20px"}}width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M11 21.883l-6.235-7.527-.765.644 7.521 9 7.479-9-.764-.645-6.236 7.529v-21.884h-1v21.883z"/></svg>					 */}
						</div>
				</div>
				<div className='myRoot'>
					<div ref={this.aboutMeRef} style={{backgroundColor:"#242424"}}>
						<div className='myMargin'>
							<AboutMeComponentV2/>
						</div>
						<div className='myMargin'>
							<FocusingComponentV2/>
						</div>
						{/* <div class='seperator'/> */}
						<div className='myMargin'>
							<ExperienceComponentV2/>
						</div>
						<div className='myMargin'>
							<PartnerComponentV2/>
						</div>
						<div className='myMargin'>
							<PublicationomponentV2/>
						</div>
						<div className='myMargin'>
							<TeachingComponentV2/>
						</div>
						<div className='myMargin'>
							<ConnectComponent/>
						</div>
						<div className='copyRightDiv'>
							Copyright © 2022 Calvin Ku
							<div style={{paddingTop: "30px"}}>
								<a>
									<ArrowCircleUpIcon 
										style={{fontSize: "40px", color: "white"}}
										onClick={()=>{
											window.scrollTo(0, this.homeRef.current.offsetTop)
										}}/>
								</a>
							</div>
							<button
								style={{marginTop: "30px"}} 
								onClick={()=>{
								window.scrollTo(0, this.homeRef.current.offsetTop) 
							}}
							className='slide'>To the top</button>
							
							
						</div>
					</div>
				</div>

				<div style={{zIndex:-1, position: "fixed"}}>
					<Particles
						id="tsparticles"
						init={this.particlesInit}
						loaded={this.particlesLoaded}
						options={{
							background: {
								color: {
								value: "#000000",
								},
							},
							interactivity: {
								events: {
								  onClick: {
									enable: true,
									mode: "push",
								  },
								  onHover: {
									enable: true,
									mode: "repulse",
								  },
								  resize: true,
								},
								modes: {
								  push: {
									quantity: 4,
								  },
								  repulse: {
									distance: 40,
									duration: 0.4,
								  },
								},
							  },
							fpsLimit: 120,
							particles: {
								color: {
									value: "#ffffff",
								},
								links: {
									color: "#ffffff",
									distance: 150,
									enable: true,
									opacity: 0.5,
									width: 1,
								},
								collisions: {
									enable: true,
								},
								move: {
									direction: "none",
									enable: true,
								outModes: {
									default: "bounce",
								},
								random: false,
								speed: 1,
								straight: false,
								},
								number: {
								density: {
									enable: true,
									area: 800,
								},
								value: 80,
								},
								opacity: {
									value: 0.5,
								},
								shape: {
									type: "circle",
								},
								size: {
									value: { min: 1, max: 5 },
								},
								// url: process.env.PUBLIC_URL+ "/img/calvin.svg"
								// url: `url(${process.env.PUBLIC_URL + '/img/calvin.svg'})`
							},
								detectRetina: true,
							}
						}/>
					</div>
			</React.Fragment>
		);
	}

}

const Redux = connect(store => ({

}))(Component);

export const NewIndexPage = Redux;
